// extracted by mini-css-extract-plugin
export default {"board":"SetCounter_board__yxxi0","setContainer":"SetCounter_setContainer__1oBQn"};